import EmptyProductList from '@pages/ProductListPage/components/EmptyProductList';
import ProductListHeader from '@pages/ProductListPage/components/ProductListHeader';
import type { ProductListAPIResponse } from '@partful/shared-types';
import { Job } from '@providers/job/types';
import { useState } from 'react';
import { ContentPadding } from 'src/components/ContentPane';
import { usePermissions } from 'src/hooks/usePermissions';
import ProductList from '../product-list';
import { getFilteredConfigurationsAndJobs } from './lib/getFilteredConfigurationsAndJobs';

export type MessageType = 'error' | 'success';
export type DisplayMessageHandler = (title: string, message: string, messageType: MessageType) => void;

interface ProductListPageProps {
  configurations: ProductListAPIResponse;
  jobs: Job[];
}

export default function ProductListLayout({ configurations, jobs }: Readonly<ProductListPageProps>) {
  const [searchFieldState, setSearchFieldState] = useState('');
  const { filteredConfigurations, filteredJobs } = getFilteredConfigurationsAndJobs(
    configurations,
    jobs,
    searchFieldState
  );

  // this ensures CreateProductCard is shown if no products are found in search
  const showCreateProductTile = usePermissions(['add', 'product']);

  return (
    <ContentPadding>
      <ProductListHeader searchFieldState={searchFieldState} setSearchFieldState={setSearchFieldState} />
      {showCreateProductTile || filteredConfigurations.length > 0 ? (
        <ProductList configurations={filteredConfigurations} jobs={filteredJobs} />
      ) : (
        /* istanbul ignore next - is this needed? */
        <EmptyProductList
          areThereAnyFetchedProducts={
            /* istanbul ignore next */ !!configurations.length || /* istanbul ignore next */ !!jobs.length
          }
          searchFieldState={searchFieldState}
        />
      )}
    </ContentPadding>
  );
}
